export default {
  signIn: '로그인',
  signOut: '로그아웃',
  points: '포인트',
  hyattSignInButton: 'World of Hyatt에 로그인',
};
